import script from "./AsociacionesAdminView.vue?vue&type=script&setup=true&lang=js"
export * from "./AsociacionesAdminView.vue?vue&type=script&setup=true&lang=js"

import "./AsociacionesAdminView.vue?vue&type=style&index=0&id=02217065&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02217065"]])

export default __exports__